import { useContext, useEffect, useState } from "react";
import axios from "../API/axios";
import AuthContext from "../Context/AuthProvider";


import {
  Box,
  Button,
  Card,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid2,
  IconButton,
  InputBase,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";

import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";
import { useSnackbar } from "../Utility/UserMessageContext";

function SearchSelectPatient({setSelectedPatient}) {
  const {showSnackbar} = useSnackbar();
  const [searchResult, setSearchResult] = useState();
  const [mobileNo, setMobileNo] = useState();
  // const errRef = useRef();
  // const addPatientErrorMessageRef = useRef();
  // const regPatientErrorMessageRef = useRef();

  // const addPatientSuccessMessageRef = useRef();
  const [errorMessage, setErrorMessage] = useState();
  const [successMessage, setSuccessMessage] = useState();

  // const [addPatientErrorMessage, setAddPatientErrorMessage] = useState();
  // const [regPatientErrorMessage, setRegPatientErrorMessage] = useState();

  // const [addPatientSuccessMessage, setAddPatientSuccessMessage] = useState();
  const PATIENT_URL = "/api/patient";
  const { auth } = useContext(AuthContext);
  const [tmpSelectedPatient, setTmpSelectedPatient] = useState();
  const [addPatientPrefix, setAddPatientPrefix] = useState();
  const [addPatientFirstName, setAddPatientFirstName] = useState();
  const [addPatientLastName, setAddPatientLastName] = useState();
  const [addPatientDoB, setAddPatientDoB] = useState();
  const [addPatientGender, setAddPatientGender] = useState();
  const [regPatientPrefix, setRegPatientPrefix] = useState();
  const [regPatientGender, setRegPatientGender] = useState();
  const [regPatientFirstName, setRegPatientFirstName] = useState();
  const [regPatientLastName, setRegPatientLastName] = useState();
  const [regPatientDoB, setRegPatientDoB] = useState();
  const [regPatientMobileNo, setRegPatientMobileNo] = useState();
  const [regPatientEmail, setRegPatientEmail] = useState();

  const getPatientsByMobileNo = async () => {
    await axios
      .get(PATIENT_URL + "/mobileno/" + mobileNo, {
        headers: { Authorization: "Bearer " + auth.authToken },
      })
      .then(function (response) {
        setSearchResult(response?.data);
      })
      .catch(function (error) {
        if (!error.response) {    
          showSnackbar("No response is received from the server.", "error");
        } else {
          showSnackbar("Error occurred while adding the patient.", "error");
        }
      });
  };

  const onSearch = async (e) => {
    e.preventDefault();
    if (mobileNo?.toString().length !== 10 || !/^\d+$/.test(mobileNo)) {
      showSnackbar("Please enter a valid mobile no.", "error");
    } else {
      await getPatientsByMobileNo();
      setSelectedPatient();
    }
      
  };

  const onAddPatientClick = async (e) => {
    e.preventDefault();

    await axios
      .post(
        PATIENT_URL,
        {
          firstName: addPatientFirstName,
          prefix: addPatientPrefix,
          lastName: addPatientLastName,
          dateOfBirth: addPatientDoB,
          gender: addPatientGender,
          mobileNo: searchResult[0].mobileNo,
          emailId: searchResult[0].emailId,
        },

        {
          headers: {
            Authorization: "Bearer " + auth.authToken,
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        getPatientsByMobileNo();
        setAddPatientFirstName("");
        setAddPatientLastName("");
        setAddPatientDoB();
        setAddPatientGender();
        setAddPatientPrefix();
        showSnackbar("A new patient is added successfully.", "success");
        //addPatientSuccessMessageRef.current.focus();
      })
      .catch(function (error) {
        if (!error.response) {    
          showSnackbar("No response is received from the server.", "error");
        } else {
          showSnackbar(error?.response?.data, "error");
        }
        console.log(JSON.stringify(error?.message));
      });
  };

  const onRegisterPatientClick = async (e) => {
    e.preventDefault();
    await axios
      .post(
        PATIENT_URL,
        {
          firstName: regPatientFirstName,
          prefix: regPatientPrefix,
          lastName: regPatientLastName,
          dateOfBirth: regPatientDoB,
          gender: regPatientGender,
          mobileNo: regPatientMobileNo,
          emailId: regPatientEmail,
        },

        {
          headers: {
            Authorization: "Bearer " + auth.authToken,
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {

        getPatientsByMobileNo();
        setRegPatientPrefix();
        
        setRegPatientDoB();
        setRegPatientFirstName();
        setRegPatientLastName();
        setRegPatientGender();
      })
      .catch(function (error) {
        if (!error.response) {    
          showSnackbar("No response is received from the server.", "error");
        } else {
          showSnackbar("Error occurred while adding the patient.", "error");
        }
      });
  };

  return (
    <Card size={12} sx={{ height: "400px", padding:"10px", overflow:"auto" }} variant="outlined">
      <Grid2
        container
        size={12}
        noValidate
        autoComplete="off"
        spacing={1}
      >
          <Paper
            
            component="form"
            onSubmit={onSearch}
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search patient by mobile no."
              onChange={(e) => {
                setMobileNo(e.target.value);
                setRegPatientMobileNo(e.target.value);
                setSearchResult(null);
                setSelectedPatient();
              }}
            />
            <IconButton disabled={mobileNo?.toString().length !== 10 || !/^\d+$/.test(mobileNo)} type="button" sx={{ p: "10px" }}  onClick={onSearch}>
              <PersonSearchIcon/>
            </IconButton>
          </Paper>
          
      </Grid2>
      {searchResult ? (
        searchResult.length > 0 ? (
          <>
            <Grid2 size={12} container sx={{marginTop:"25px"}}>
              <FormControl>
                <FormLabel>Choose one patient to proceed.</FormLabel>
                <RadioGroup
                  onChange={(e) =>
                    setSelectedPatient(
                      searchResult?.find(
                        (a) => a.id.toString() === e.target.value
                      )
                    )
                  }
                >
                  {searchResult?.map((patient) => (
                    <FormControlLabel
                      value={patient.id}
                      control={<Radio />}
                      label={`${patient.prefix} ${patient.firstName} ${patient.lastName}, ${patient.gender}, ${patient.ageInYears} Years`}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Grid2>
            <a href="#addPatientCollapse" data-bs-toggle="collapse">
              Add another patient with same mobile no.
            </a>
            <div class="collapse" id="addPatientCollapse">
              <Card variant="outlined" sx={{padding:"10px"}}>
                <Grid2 container size={12} spacing={2}>
                <Grid2 container size={12} spacing={2}>
                  <Grid2 size={2} >
                    <FormControl fullWidth>
                      <InputLabel>Prefix</InputLabel>
                      <Select
                        label="Prefix"
                        value={addPatientPrefix}
                        onChange={(e) => {
                          setAddPatientPrefix(e.target.value);
                        }}
                      >
                        <MenuItem value="Mr." selected>
                          Mr.
                        </MenuItem>
                        <MenuItem value="Ms.">Ms.</MenuItem>
                        <MenuItem value="Mrs.">Mrs.</MenuItem>
                        <MenuItem value="Dr.">Dr.</MenuItem>
                        <MenuItem value="Others">Others</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid2>
                  <Grid2 size={5}>
                    <TextField
                      fullWidth
                      label="First Name"
                      value={addPatientFirstName}
                      onChange={(e) => {
                        setAddPatientFirstName(e.target.value);
                      }}
                    ></TextField>
                  </Grid2>
                  <Grid2 size={5}>
                    <TextField
                      fullWidth
                      label="Last Name"
                      value={addPatientLastName}
                      onChange={(e) => {
                        setAddPatientLastName(e.target.value);
                      }}
                    ></TextField>
                  </Grid2>
                </Grid2>
                <Grid2 container size={12} spacing={2}>
                  <Grid2 size={6}>
                    <FormControl fullWidth>
                      <InputLabel>Gender</InputLabel>
                      <Select
                        label="Gender"
                        value={addPatientGender}
                        onChange={(e) => {
                          setAddPatientGender(e.target.value);
                        }}
                      >
                        <MenuItem value="Male" selected>
                          Male
                        </MenuItem>
                        <MenuItem value="Female">Female</MenuItem>
                        <MenuItem value="Others">Others</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid2>
                  <Grid2 size={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Date of Birth"
                        sx={{ width: "100%" }}
                        maxDate={dayjs(new Date())}
                        value={addPatientDoB}
                        onChange={(value) => setAddPatientDoB(value)}
                      />
                    </LocalizationProvider>
                  </Grid2>
                </Grid2>

                <Grid2 container size={12} sx={{justifyContent:"center"}}>
                  <Button
                    variant="contained"
                    color="secondary"
                    class="btn btn-primary ms-1"
                    type="submit"
                    onClick={onAddPatientClick}
                    disabled={
                      !addPatientFirstName ||
                      !addPatientLastName ||
                      !addPatientDoB
                    }
                  >
                    Add Patient
                  </Button>
                </Grid2>
                </Grid2>
              </Card>
            </div>
          </>
        ) : (
          <Grid2 container spacing={2}>
            <Grid2 size={12}>
              <InputLabel sx={{paddingTop:"25px"}}>
                No patient found. 
                Register a new patient.
              </InputLabel>
            </Grid2>
            <Grid2 container size={12}>
              <Grid2 size={2}>
                <FormControl fullWidth>
                  <InputLabel>Prefix</InputLabel>
                  <Select
                    label="Prefix"
                    value={regPatientPrefix}
                    onChange={(e) => {
                      setRegPatientPrefix(e.target.value);
                    }}
                  >
                    <MenuItem value="Mr." selected>
                      Mr.
                    </MenuItem>
                    <MenuItem value="Ms.">Ms.</MenuItem>
                    <MenuItem value="Mrs.">Mrs.</MenuItem>
                    <MenuItem value="Dr.">Dr.</MenuItem>
                    <MenuItem value="Others">Others</MenuItem>
                  </Select>
                </FormControl>
              </Grid2>
              <Grid2 size={5}>
                <TextField
                  fullWidth
                  label="First Name"
                  value={regPatientFirstName}
                  onChange={(e) => {
                    setRegPatientFirstName(e.target.value);
                  }}
                ></TextField>
              </Grid2>
              <Grid2 size={5}>
                <TextField
                  fullWidth
                  label="Last Name"
                  value={regPatientLastName}
                  onChange={(e) => {
                    setRegPatientLastName(e.target.value);
                  }}
                ></TextField>
              </Grid2>
            </Grid2>
            <Grid2 container size={12}>
              <Grid2 size={6}>
                <FormControl fullWidth>
                  <InputLabel>Gender</InputLabel>
                  <Select
                    label="Gender"
                    value={regPatientGender}
                    onChange={(e) => {
                      setRegPatientGender(e.target.value);
                    }}
                  >
                    <MenuItem value="Male" selected>
                      Male
                    </MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Others">Others</MenuItem>
                  </Select>
                </FormControl>
              </Grid2>
              <Grid2 size={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Date of Birth"
                    sx={{ width: "100%" }}
                    maxDate={dayjs(new Date())}
                    value={regPatientDoB}
                    onChange={(value) => setRegPatientDoB(value)}
                  />
                </LocalizationProvider>
              </Grid2>
            </Grid2>
            <Grid2 container size={12}>
              <Grid2 size={6}>
                <FormControl fullWidth>
                  <InputLabel shrink>Mobile No</InputLabel>
                  <TextField
                    label="Mobile No."
                    fullWidth
                    value={regPatientMobileNo}
                    onChange={(e) => setRegPatientMobileNo(e.target.value)}
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  ></TextField>
                </FormControl>
              </Grid2>
              <Grid2 size={6}>
                <TextField
                  label="Email Id"
                  fullWidth
                  type="email"
                  value={regPatientEmail}
                  onChange={(e) => setRegPatientEmail(e.target.value)}
                ></TextField>
              </Grid2>
            </Grid2>

            <Grid2 size={12} container sx={{ justifyContent: "center" }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={onRegisterPatientClick}
                disabled={
                  !regPatientEmail ||
                  !regPatientMobileNo ||
                  !regPatientFirstName ||
                  !regPatientDoB ||
                  !regPatientLastName
                }
              >
                Register
              </Button>
            </Grid2>
          </Grid2>
        )
      ) : (
        <></>
      )}
    </Card>
  );
}

export default SearchSelectPatient;
